import { useMutation } from "react-query";
import { KpcInstance } from "../instance";

// KPC 원장 중 미완료 전송 건만 영일데이타로 다시 전송한다.
export const useKpcScanResend = () =>
  useMutation((scandate) =>
    KpcInstance.post("/customer/scans/resend", { scandate }),
  );
